import React from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core'
import QueueCard from './QueueCard'
import { useV4Styles } from './v4Styles'

const QueueList = ({ items, loading, selectedId, onSelect }) => {
  const classes = useV4Styles()

  if (loading) {
    return (
      <div className={classes.queuePanel}>
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress size={28} />
        </Box>
      </div>
    )
  }

  return (
    <div className={classes.queuePanel}>
      <div className={classes.queueListHeader}>
        Queue &mdash; Sorted by Priority + Urgency
      </div>
      {!items.length ? (
        <Box p={3}>
          <Typography color="textSecondary" variant="body2" align="center">
            No sites match the current filters.
          </Typography>
        </Box>
      ) : (
        items.map(item => (
          <QueueCard
            key={item._id}
            item={item}
            selected={item._id === selectedId}
            onClick={onSelect}
          />
        ))
      )}
    </div>
  )
}

export default QueueList
